import { ActionTree } from 'vuex';
import { LayoutState, RootState } from '../types';

export const actions: ActionTree<LayoutState, RootState> = {
	setTabBar({ commit }, isDisplayed: boolean): void {
		commit('SET_TAB_BAR', isDisplayed);
	}
};